import keyMirror from 'keymirror';

export const folderDetailsActionTypes = keyMirror({
	GET_FOLDER_DETAILS_REQUEST: null,
	GET_FOLDER_DETAILS_SUCCESS: null,
	GET_FOLDER_DETAILS_ERROR: null,

	TOGGLE_FOLDER_ADD_LIST_MODAL: null,
	FOLDER_ADD_ITEMS_REQUEST: null,
	FOLDER_ADD_ITEMS_SUCCESS: null,
	FOLDER_ADD_ITEMS_ERROR: null,

	UPDATE_FOLDER_REQUEST: null,
	UPDATE_FOLDER_SUCCESS: null,
	UPDATE_FOLDER_ERROR: null,

	DELETE_FOLDER_REQUEST: null,
	DELETE_FOLDER_ERROR: null,

	DELETE_LIST_FROM_FOLDER_REQUEST: null,
	DELETE_LIST_FROM_FOLDER_SUCCESS: null,
	DELETE_LIST_FROM_FOLDER_ERROR: null,

	CLEAR_FOLDER_DETAILS: null,
});

export const getSortingOptions = (t) => [
	{ title: t('group_details.sorting_options.last_added'), key: 'added_to_folder_at_timestamp' },
	{ title: t('group_details.sorting_options.last_practiced'), key: 'last_practiced_timestamp' },
	{ title: t('group_details.sorting_options.alphabetical'), key: 'alphabetical' },
	{ title: t('group_details.sorting_options.language'), key: 'language' },
];
